function ArrowIcon({className, handleClick}) {
	return (
		<svg
			className={`arrow-icon ${className}`}
			onClick={handleClick}
			width='48px'
			height='48px'
			viewBox='0 0 48 48'
			version='1.1'
		>
			<defs></defs>
			<g
				id='Page-1'
				stroke='none'
				strokeWidth='1'
				fill='none'
				fillRule='evenodd'
			>
				<g id='Catalog-p2' transform='translate(-1200.000000, -512.000000)'>
					<g id='menu' transform='translate(132.000000, 512.000000)'>
						<g id='arrow-left' transform='translate(1068.000000, 0.000000)'>
							<g id='Group-15'>
								<circle
									id='Oval-4'
									stroke='#D9D9D9'
									cx='24'
									cy='24'
									r='23.5'
								></circle>
								<polygon
									id='Shape'
									fill='#D9D9D9'
									transform='translate(24.000000, 23.705000) rotate(-270.000000) translate(-24.000000, -23.705000) '
									points='28.59 20 24 24.58 19.41 20 18 21.41 24 27.41 30 21.41'
								></polygon>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
}
export default ArrowIcon;
